/**
 * MAPA DE ENDPOINTS: Turn ↔ TFSM
 *
 * Cada objeto define la equivalencia entre un endpoint del backend Turn
 * y su contraparte en el backend TFSM (Toyota), junto con el método HTTP.
 *
 * ALGORITMO DE RESOLUCIÓN (transformServiceUrl):
 *   1. Filtra entradas por método HTTP.
 *   2. Ordena por longitud del turn path DESCENDENTE (rutas más específicas primero).
 *   3. Toma el PRIMER match — el orden de inserción es determinante cuando
 *      dos entradas tienen turn paths de igual longitud.
 *
 * DOS PATRONES VÁLIDOS EN ESTE ARRAY:
 *
 *   A) N turn → 1 tfsm  (intencional)
 *      Varios endpoints Turn apuntan al mismo endpoint TFSM.
 *      Ej: /vehicles/dashboard/report  y  /vehicles/dashboard/vehicle-prom-approved-report
 *          ambos resuelven a /TfsmRetieveVehiclesReport
 *
 *   B) 1 turn → N tfsm  (legacy controlado — ¡ORDEN IMPORTA!)
 *      El mismo turn path tiene dos entradas tfsm de fases distintas del proyecto.
 *      La entrada que aparece PRIMERO es la activa; la segunda es legacy.
 *      NO reordenar estas entradas sin revisar el patrón completo.
 *      Casos activos documentados:
 *        turn: /bitacora/logbook/tracking  GET  → activo: TfsmGetLogBook        / legacy: TfsmGetLogBookJson
 *        turn: /vehicles/change-status     POST → activo: TfsmVehiclesChangeStatus / legacy: TFSMChangeStatus
 *        turn: /groupsagencies/agencies    GET  → activo: TfsmGetAgenciesJson   / legacy: TfsmAgency
 *        turn: /seguridad/user             PUT  → activo: TfsmActualizarUsuario  / legacy: TfsmUserActualizarUsuario
 *        turn: /vehicles/vehicle           GET  → activo: TFSMGetVehicleById     / legacy: TFSMGetVehiclesList
 *
 * REGLA AL AGREGAR ENTRADAS:
 *   - Si el turn+method ya existe, coloca la nueva entrada AL FINAL y documenta
 *     por qué coexiste. Nunca insertar antes de una entrada activa existente.
 */
const services = [
  {
    "tfsm":"/preCheckRfc",
    "turn": "/vehicles/pre-calificacion/check",
    "method": "get"
  },
  {
    "tfsm":"/tfsm/Cotizador/GoKey/showCotization",
    "turn": "/vehicles/quote",
    "method": "get",
    "fromOrigin": true
  },
  {
    "tfsm":"/retrieveTasks",
    "turn": "/vehicles/bus-tasks/next",
    "method": "get"
  },
  {
    "tfsm":"/retrieveTasksWithInformation",
    "turn": "/vehicles/bus-tasks/complete",
    "method": "get"
  },
  
/*   {
    "tfsm":"/showCotization",
    "turn": "/vehicles/quote",
    "method": "get"
  }, */
  {
    "tfsm":"/tfsm/Cotizador/GoKey/createCotization",
    "turn": "/vehicles/quote",
    "method": "post",
    "fromOrigin": true
  },
  {
    "tfsm":"/TfsmImageVehicleBorrador",
    "turn": "/vehicles/image_borrador",
    "method": "post"
  },
  {
    "tfsm":"/TfsmCargaVehicleImages",
    "turn": "/vehicles/image",
    "method": "post"
  },
  {
    "tfsm":"/TfsmHasPermission",
    "turn": "/seguridad/hasPermission",
    "method": "post"
  },

  {
    "tfsm":"/TfsmCheckUser",
    "turn": "/seguridad/checkUser",
    "method": "post"
  },
  {
    "tfsm":"/TfsmBorrarUsuario",
    "turn": "/seguridad/user",
    "method": "delete"
  },
  {
    "tfsm":"/TfsmGetModulosPermisosPorUUID",
    "turn": "/seguridad/treeModulePermissionByUser",
    "method": "get"
  },
  {
    "tfsm":"/TfsmGetAgenciesJson",
    "turn": "/groupsagencies/agencies",
    "method": "get"
  },
  {
    "tfsm":"/TfsmSaveAgency",
    "turn": "/groupsagencies/agencies",
    "method": "post"
  },
  {
    "tfsm":"/TfsmUpdateAgency",
    "turn": "/groupsagencies/agencies",
    "method": "put"
  },
  // {
  //   "tfsm":"/TfsmUpdateAgency",
  //   "turn": "/groupsagencies/agencies",
  //   "method": "put"
  // },
  {
    "tfsm":"/TfsmGetGroups",
    "turn": "/groupsagencies/groups",
    "method": "get"
  },
  {
    "tfsm":"/TfsmActualizarRoles",
    "turn": "/seguridad/roles",
    "method": "put"
  },
  {
    "tfsm":"/TfsmCrearRoles",
    "turn": "/seguridad/roles",
    "method": "post"
  },
  {
    "tfsm":"/TfsmGetTypeLogNotDatatables",
    "turn": "/bitacora/typeeventlogs",
    "method": "get"
  },
  
  {
    "tfsm":"/TfsmGetVehicles/vehicles/brands",
    "turn": "/vehicles/brands",
    "method": "get"
  },
  {
    "tfsm":"/TfsmGetVehicles/vehicles/years",
    "turn": "/vehicles/years",
    "method": "get"
  },
  {
    "tfsm":"/TfsmGetVehicles/vehicles/models",
    "turn": "/vehicles/models",
    "method": "get"
  },
  {
    "tfsm":"/ValorSeminuevos",
    "turn": "/vehicles/millions",
    "method": "get"
  },
  {
    "tfsm":"/TfsmObtenerVehiculosPorEstado",
    "turn": "/vehicles/states",
    "method": "get"
  },
  {
    "tfsm":"/BrandsBorrador/1",
    "turn": "/vehicles/brands_borrador/1",
    "method": "get"
  },
  {
    "tfsm":"/TFSMGetStatus",
    "turn": "/vehicles/status",
    "method": "get"
  },
  {
    "tfsm":"/TFSMEditVehicle",
    "turn": "/vehicles/vehicle",
    "method": "put"
  },
  {
    "tfsm":"/TFSMGetBodyType",
    "turn": "/vehicles/type",
    "method": "get"
  },
  {
    "tfsm":"/TfsmSaveAgency",
    "turn": "/groupsagencies/agencies",
    "method": "post"
  },
  {
    "tfsm":"/TfsmSetGroupAgencies",
    "turn": "/groupsagencies/agencies/groups",
    "method": "put"
  },
  {
    "tfsm":"/TfsmDeleteGroup",
    "turn": "/groupsagencies/groups",
    "method": "delete"
  },
  {
    "tfsm":"/TfsmSaveGroup",
    "turn":"/groupsagencies/groups" ,
    "method": "post"
  },
  {
    "tfsm":"/TfsmUpdateGroup",
    "turn": "/groupsagencies/groups",
    "method": "put"
  },
  {
    "tfsm":"/TfsmActualizarRoles",
    "turn": "/seguridad/roles",
    "method": "put"
  },
  {
    "tfsm":"/TfsmCrearRoles",
    "turn": "/seguridad/roles",
    "method": "post"
  },
  {
    "tfsm":"/TfsmRelRoleModulePermission",
    "turn": "/seguridad/treeModulePermission",
    "method": "get"
  },
  {
    "tfsm":"/TfsmTreeRoleModulePermission",
    "turn": "/seguridad/treeRoleModulePermission",
    "method": "get"
  },
  {
    "tfsm":"/TfsmDetalleRolesPorId",
    "turn": "/seguridad/rolesByID",
    "method": "get"
  },
  {
    "tfsm":"/TfsmCrearUsuario",
    "turn": "/seguridad/user",
    "method": "post"
  },
  {
    "tfsm":"/TfsmCrearUserEnterprise",
    "turn": "/seguridad/usersEnterprise",
    "method": "post"
  },
  {
    "tfsm":"/TfsmActualizarUsuario",
    "turn": "/seguridad/user",
    "method": "put"
  },
  {
    "tfsm":"/TfsmActualizarUserEnterprise",
    "turn": "/seguridad/usersEnterprise",
    "method": "put"
  },
  {
    "tfsm":"/TfsmNewVehicleFeature",
    "turn": "/vehicles/feature",
    "method": "post"
  },
  {
    "tfsm":"/TfsmBorraImagenesVehicle/",
    "turn": "/vehicles/images/",
    "method": "delete"
  },
  {
    "tfsm":"/ListadoVehiculos",
    "turn": "/vehicles/vehicle_borrador",
    "method": "get"
  },
  {
    "tfsm":"/tfsm/GoKey/retrieveDraftVehicle/vehicleBorrador",
    "turn": "/vehicles/vehicle_borradors",
    "method": "get",
    "fromOrigin": true
  },
  {
    "tfsm":"/VehicleBorrador",
    "turn": "/vehicles/vehicle_borrador",
    "method": "delete"
  },
  {
    "tfsm":"/VehicleBorrador",
    "turn": "/vehicles/vehicle_borrador",
    "method": "put"
  },
  {
    "tfsm":"/ImagenBorrador",
    "turn": "/vehicles/images_borrador",
    "method": "delete"
  },
  {
    "tfsm":"/NewVehicleBorrador",
    "turn": "/vehicles/vehicle_borrador",
    "method": "post"
  },
  {
    "tfsm":"/TfsmTransmission",
    "turn": "/vehicles/transmission",
    "method": "get"
  },
  {
    "tfsm":"/TfsmFuel",
    "turn": "/vehicles/fuel",
    "method": "get"
  },
  {
    "tfsm":"/TfsmFeatures",
    "turn": "/vehicles/feature",
    "method": "get"
  },
  {
    "tfsm":"/TfsmDeleteByVehicle",
    "turn": "/vehicles/feature",
    "method": "delete"
  },
  {
    "tfsm":"/TfsmVehiclesMedios",
    "turn": "/vehicles/medios",
    "method": "get"
  },
  {
    "tfsm":"/TfsmForgotPassword",
    "turn": "/seguridad/userForgotPassword",
    "method": "post"
  },
  {
    "tfsm":"/TfsmUserEnterpriseByUuid",
    "turn": "/seguridad/getUserEnterpriseByUuid",
    "method": "get"
  },
  {
    "tfsm":"/TfsmDeleteAgency",
    "turn": "/groupsagencies/agencies",
    "method": "delete"
  },
  {
    "tfsm":"/TfsmGetConfigurations",
    "turn": "/configurations",
    "method": "get"
  },
  {
    "tfsm":"/TfsmUpdatePassword",
    "turn": "/seguridad/passwordSet",
    "method": "post"
  },
  {
    "tfsm":"/TfsmLoginUser",
    "turn": "/seguridad/userLogin",
    "method": "post"
  },
  {
    "tfsm":"/TFSMGetAllDomainsJson",
    "turn": "/groupsagencies/domains",
    "method": "get"
  },
  // {
  //   "tfsm":"/TfsmGetAllDomains",
  //   "turn": "/groupsagencies/domains",
  //   "method": "get"
  // },
  {
    "tfsm":"/TfsmLogUsersCreated",
    "turn": "/bitacora/logbook/loguserscreated",
    "method": "get"
  },
  // {
  //   "tfsm":"/TfsmLogUsersCreatedJson",
  //   "turn": "/bitacora/logbook/loguserscreated",
  //   "method": "get"
  // },
  {
    "tfsm":"/TfsmGetLogBook",
    "turn": "/bitacora/logbook/tracking",
    "method": "get"
  },
  // LEGACY (patrón B) — mismo turn path que TfsmGetLogBook. TfsmGetLogBook resuelve primero por posición en el array.
  {
    "tfsm":"/TfsmGetLogBookJson",
    "turn": "/bitacora/logbook/tracking",
    "method": "get"
  },
  {
    "tfsm":"/TfsmObtenerRoles",
    "turn": "/seguridad/roles",
    "method": "get"
  },
  {
    "tfsm":"/TfsmUsersByRoles",
    "turn": "/seguridad/usersByRoles",
    "method": "get"
  },
  {
    "tfsm":"/TFSMDeleteRol",
    "turn": "/seguridad/deleteRole",
    "method": "delete"
  },
  
  {
    "tfsm":"/TfsmUpdateConfiguration",
    "turn": "/configurations",
    "method": "put"
  },
  {
    "tfsm":"/TfsmNewVehiclesListReport",
    "turn": "/vehicles/vehicle-list/report",
    "method": "get"
  },
  {
    "tfsm":"/TfsmSearchVehicleDraft",
    "turn": "/vehicles/search_borrador",
    "method": "get"
  },
  // {
  //   "tfsm":"/TfsmSearchByQueryString?str=",
  //   "turn": "/vehicles/vehicle-list?str=",
  //   "method": "get"
  // },
  {
    "tfsm":"/TfsmVehiclesChangeStatus",
    "turn": "/vehicles/change-status",
    "method": "post"
  },
  {
    "tfsm":"/TFSMGetVehicleById",
    "turn": "/vehicles/vehicle",
    "method": "get"
  },
  {
    "tfsm":"/tfsm/GoKey/MP/IdentifierSync",
    "turn": "/vehicles/resolve-maxi-id",
    "method": "get",
    "fromOrigin": true
  },
  {
    "tfsm":"/TfsmShowVehicleImages",
    "turn": "/vehicles/image",
    "method": "get"
  },
  {
    "tfsm":"/tfsm/GoKey/retrieveImageDraft",
    "turn": "/vehicles/image_borrador",
    "method": "get",
    "fromOrigin": true
  },
  // LEGACY (patrón B) — mismo turn path que TfsmVehiclesChangeStatus. TfsmVehiclesChangeStatus resuelve primero por posición en el array.
  {
    "tfsm":"/TFSMChangeStatus",
    "turn": "/vehicles/change-status",
    "method": "post"
  },
  {
    "tfsm":"/TfsmVehiculosRecientes",
    "turn": "/vehicles/recent",
    "method": "get"
  },
  // Fase Dos
  {
    "tfsm":"/TfsmRetieveDashboardVehicles",
    "turn": "/vehicles/dashboard",
    "method": "get"
  },
  {
    "tfsm":"/TfsmRretieveDashboardAgencies",
    "turn": "/vehicles/dashboard/catalogue/agencies",
    "method": "get"
  },
  {
    "tfsm":"/TfsmRetieveDashboardGroups",
    "turn": "/vehicles/dashboard/catalogue/groups",
    "method": "get"
  },
  {
    "tfsm":"/TfsmRetieveVehiclesReport",
    "turn": "/vehicles/dashboard/report",
    "method": "get"
  },
  {
    "tfsm":"/TfsmRetieveVehiclesReport",
    "turn": "/vehicles/dashboard/vehicle-prom-approved-report",
    "method": "get"
  },
  {
    "tfsm":"/TfsmRetieveLeadsReport",
    "turn": "/vehicles/dashboard/vehicle-leads-report",
    "method": "get"
  },
  {
    "tfsm":"/TfsmDeleteVehiclesById",
    "turn": "/vehicles/vehicle-destroy-reason",
    "method": "put"
  },
  {
    "tfsm":"/TfsmNewVehiclesList",
    "turn": "/vehicles/vehicle-list",
    "method": "get"
  },
  {
    "tfsm":"/TfsmCreateVehiclesLead",
    "turn": "/vehicles/lead",
    "method": "post"
  },
  {
    "tfsm":"/TfsmFavoriteVehicleById",
    "turn": "/vehicles/favorite",
    "method": "post"
  },
  {
    "tfsm":"/TfsmRetrieveFavoritesVehicles",
    "turn": "/vehicles/favorites",
    "method": "get"
  },
  {
    "tfsm":"/TfsmSetFavoriteVehicles",
    "turn": "/vehicles/favorites",
    "method": "post"
  },
  {
    "tfsm":"/TfsmVehicleViewById",
    "turn": "/vehicles/view",
    "method": "post"
  },
  {
    "tfsm":"/TfsmRetrieveVehiclesViews",
    "turn": "/vehicles/views",
    "method": "get"
  },
  // {
  //   "tfsm":"/TfsmCreateHomeBanner",
  //   "turn": "/vehicles/banners/home",
  //   "method": "post"
  // },
  {
    "tfsm":"/TfsmHomeBanner",
    "turn": "/vehicles/banners/home",
    "method": "get"
  },
  {
    "tfsm":"/TfsmUpdateHomeBanner",
    "turn": "/vehicles/banners/home",
    "method": "post"
  },
  {
    "tfsm":"/TfsmRetrieveMarketplaceBanner",
    "turn": "/vehicles/banners/marketplace",
    "method": "get"
  },
  // {
  //   "tfsm":"/TfsmCreateMarketplaceBanner",
  //   "turn": "/vehicles/banners/marketplace",
  //   "method": "post"
  // },
  {
    "tfsm":"/TfsmUpdateMarketplaceBanner",
    "turn": "/vehicles/banners/marketplace",
    "method": "post"
  },
  // {
  //   "tfsm":"/TfsmCreateDetailsBanner",
  //   "turn": "/vehicles/banners/detail",
  //   "method": "post"
  // },
  {
    "tfsm":"/TfsmBannerDetails",
    "turn": "/vehicles/banners/detail",
    "method": "get"
  },
  {
    "tfsm":"/TfsmUpdateDetailsBanner",
    "turn": "/vehicles/banners/detail",
    "method": "post"
  },
  {
    "tfsm":"/TfsmRetrieveBannersType",
    "turn": "/vehicles/banners",
    "method": "get"
  },
  {
    "tfsm":"/TfsmDeleteBanner",
    "turn": "/vehicles/banners",
    "method": "delete"
  },
  {
    "tfsm":"/TfsmDeleteBanner",
    "turn": "/leads/agencies",
    "method": "delete"
  },
  {
    "tfsm":"/tfsm/Cotizador/GoKey/getLeadAgencies",
    "turn": "/leads/agencies",
    "method": "get",
    "fromOrigin": true
  },
  /*{
    "tfsm":"/getLeadAgencies",
    "turn": "/leads/agencies",
    "method": "get"
  },*/ 
  {
    "tfsm":"/tfsm/Cotizador/GoKey/getLeadAgencyDomain",
    "turn": "/leads/agencies/domains",
    "method": "get",
    "fromOrigin": true
  },
  /*{
    "tfsm":"/getLeadAgencyDomain",
    "turn": "/leads/agencies/domains",
    "method": "get"
  },*/
  {
    "tfsm":"/tfsm/Cotizador/GoKey/createLeadAgency",
    "turn": "/leads/agencies/emails",
    "method": "post",
    "fromOrigin": true
  },
  /*{
    "tfsm":"/createLeadAgency",
    "turn": "/leads/agencies/emails",
    "method": "post"
  },*/
  {
    "tfsm":"/tfsm/Cotizador/GoKey/deleteLeadsAgencies",
    "turn": "/leads/agencies/emails",
    "method": "delete",
    "fromOrigin": true
  },
  /*{
    "tfsm":"/deleteLeadsAgencies",
    "turn": "/leads/agencies/emails",
    "method": "delete"
  },*/
 {
    "tfsm":"/tfsm/Cotizador/GoKey/getLeadEmails",
    "turn": "/leads/agencies/emails",
    "method": "get",
    "fromOrigin": true
  },
  /*{
    "tfsm":"/getLeadEmails",
    "turn": "/leads/agencies/emails",
    "method": "get"
  },*/
  {
    "tfsm":"/tfsm/Cotizador/GoKey/getLeadLog",
    "turn": "/leads/agencies/emails/log",
    "method": "get",
    "fromOrigin": true
  },
  /*{
    "tfsm":"/getLeadLog",
    "turn": "/leads/agencies/emails/log",
    "method": "get"
  },*/
  {
    "tfsm":"/tfsm/Cotizador/GoKey/updateLeadStatus",
    "turn": "/leads/agencies/emails/log",
    "method": "post",
    "fromOrigin": true
  },
  /*{
    "tfsm":"/updateLeadStatus",
    "turn": "/leads/agencies/emails/log",
    "method": "post"
  },*/
  {
    "tfsm":"/TFSMbanner",
    "turn": "/vehicles/banners/site",
    "method": "get"
  },
  
  {
    "tfsm":"/TfsmApprovedByVehicleId",
    "turn": "/vehicles/vehicle-approved-time",
    "method": "get"
  },
  {
    "tfsm":"/TFSMSellVehicle",
    "turn": "/vehicles/sell",
    "method": "post"
  },
  {
    "tfsm":"/TfsmVehiclesHealthcheck",
    "turn": "/vehicles/healthcheck",
    "method": "get"
  },
  // LEGACY (patrón B) — mismo turn path que TfsmGetAgenciesJson. TfsmGetAgenciesJson resuelve primero por posición en el array.
  {
    "tfsm":"/TfsmAgency",
    "turn": "/groupsagencies/agencies",
    "method": "get"
  },
  {
    "tfsm":"/TfsmCreateCustomerPreCheck",
    "turn": "/vehicles/pre-calificacion",
    "method": "post"
  },
  {
    "tfsm":"/TfsmCreateCustomer",
    "turn": "/seguridad/customers",
    "method": "post"
  },
  {
    "tfsm":"/TfsmCustomerLogin",
    "turn": "/seguridad/customers/login",
    "method": "post"
  },
  {
    "tfsm":"/TfsmRetrieveCustomerByUUID",
    "turn": "/seguridad/customers",
    "method": "get"
  },
  {
    "tfsm":"/TfsmCustomersLogout",
    "turn": "/seguridad/customers/logout",
    "method": "get"
  },
  {
    "tfsm":"/TfsmVerifyCustomersEmail",
    "turn": "/seguridad/customers/verify",
    "method": "post"
  },
  {
    "tfsm":"/TfsmUpdateCustomersEmail",
    "turn": "/seguridad/customers/changeEmail",
    "method": "post"
  },
  {
    "tfsm":"/TfsmUpdateCustomer",
    "turn": "/seguridad/customers",
    "method": "put"
  },
  {
    "tfsm":"/TfsmRetrieveVehiclesLead",
    "turn": "/vehicles/leads",
    "method": "get"
  },

  /// falta el servicio del BUS

  {
    "tfsm":"/TfsmCustomerForgotPassword",
    "turn": "/seguridad/customers/forgotPasswd",
    "method": "post"
  },

  ////////////////////////////

  {
    "tfsm":"/TfsmLoginToResetPassword",
    "turn": "/seguridad/customers/log-in",
    "method": "post"
  },
  {
    "tfsm":"/TfsmResetPassword",
    "turn": "/seguridad/customers/resetPasswd",
    "method": "post"
  },
  {
    "tfsm":"/TfsmValidateContactInformation",
    "turn": "/seguridad/customers/validate",
    "method": "post"
  },
  {
    "tfsm":"/TfsmChatHealthcheck",
    "turn": "/chat/healthcheck",
    "method": "get"
  },
  {
    "tfsm":"/TfsmCreateChatUser",
    "turn": "/chat/user",
    "method": "post"
  },
  {
    "tfsm":"/TfsmUpdateChatUser",
    "turn": "/chat/update-user",
    "method": "post"
  },
  {
    "tfsm":"/TfsmUpdateChatUser",
    "turn": "/chat/update-user",
    "method": "post"
  },
  {
    "tfsm":"/TfsmCreateSentMenssage",
    "turn": "/chat/message-sent",
    "method": "post"
  },
  {
    "tfsm":"/TfsmretrieveChatSala",
    "turn": "/chat",
    "method": "get"
  },
  {
    "tfsm":"/TfsmRetrieveChatWith",
    "turn": "/chat/with",
    "method": "get"
  },
  {
    "tfsm":"/TfsmAuthenticateChatUser",
    "turn": "/chat/auth/user",
    "method": "post"
  },

  {
    "tfsm":"/TfsmRetrieveChatUsersByAgency",
    "turn": "/chat/users",
    "method": "get"
  },
  {
    "tfsm":"/TfsmRetrieveMyChats",
    "turn": "/chat/my-chats",
    "method": "get"
  },
  {
    "tfsm":"/TfsmUpdateChatStatus",
    "turn": "/chat/set/status",
    "method": "post"
  },
  {
    "tfsm":"/TfsmUpdateMessageStatus",
    "turn": "/chat/unread",
    "method": "post"
  },
  {
    "tfsm":"/TfsmSetMessagesRead",
    "turn": "/chat/read-all-messages",
    "method": "post"
  },
  {
    "tfsm":"/TFSMretriveSocketIo",
    "turn": "/socket.io",
    "method": "get"
  },
  
  // Pendiente de revisar
  {
    "tfsm":"/TfsmRoomChatUsers/:sala_chat/users",
    "turn": "/chat/:sala_chat/users",
    "method": "get",
    "idDinamic": true
  },
  {
    "tfsm":"/TfsmChatMessage/:sala_chat/messages/:monts",
    "turn": "/chat/:sala_chat/messages/:monts",
    "method": "get",
    "idDinamic": true
  },
  {
    "tfsm":"/TfsmChatImg/:sala_chat/images",
    "turn": "/chat/:sala_chat/images",
    "method": "post",
    "idDinamic": true
  },
  // final fase dos

  ////////
  // Tfsm fase uno /TfsmGetVehicleFilters",
  {
    "tfsm":"/TfsmGetVehicleFilters",
    "turn": "/vehicles/filters",
    "method": "get"
  },
   
  // Tfsm fase uno /TfsmObtenerDetalleUsuarioByUUID
  {
    "tfsm":"/TfsmDetalleUsuarioByUUID",
    "turn": "/seguridad/getUserByUuid",
    "method": "get"
  },
  {
    "tfsm":"/TfsmGetUserEnterpriseByUuid",
    "turn": "/seguridad/usersEnterpriseById",
    "method": "get"
  },
  ///
  //Tfsm fase uno /TfsmLoginUserEnterprise
  {
    "tfsm":"/tfsmLoginUsuarioEnterprise",
    "turn": "/seguridad/usersEnterpriseLogin",
    "method": "post"
  },
  ///
  // Tfsm fase uno /TfsmDeleteVehicleById/vehicles/vehicle/
  {
    "tfsm":"/TFSMDeleteVehicle",
    "turn": "/vehicles/vehicle",
    "method": "delete"
  },
  ///
  // Tfsm fase uno /TFSMCreateNewVehicle
  {
    "tfsm":"/TfsmNewVehicle",
    "turn": "/vehicles/vehicle",
    "method": "post"
  },
  ///
  // Fase uno /TfsmListadoDeUsuariosFiltro
  {
    "tfsm":"/TfsmBusquedaUsuarioPorAgencias",
    "turn": "/seguridad/relUserPermission",
    "method": "get"
  },
  // el metodo /TfsmOrdenarRoles añadido en la fase dos, es igual a TfsmObtenerRoles pero con parametros
  {
    "tfsm":"/TfsmObtenerRoles",
    "turn": "/seguridad/roles",
    "method": "get"
  },

   // servicios de la fase uno, revisados/modificados/añadidos en la fase dos

   // servicios añadidos de la fase uno que no se ocupan
   {
    "tfsm":"/TfsmUserPermissionModule",
    "turn": "/seguridad/userRolePermissionModuleByID",
    "method": "post"
    },
    {
      "tfsm":"/TfsmSaveMakerUser",
      "turn": "/bitacora/logbook/makeuser",
      "method": "post"
    },
    {
      "tfsm":"/TfsmDeleteAllGroupDependences",
      "turn": "/seguridad/deleteAllGroupDependences",
      "method": "put"
    },
    {
      "tfsm":"/TfsmCrearModules",
      "turn": "/seguridad/module",
      "method": "post"
    },
    {
      "tfsm":"/TfsmObtenerModules",
      "turn": "/seguridad/module",
      "method": "get"
    },
    {
      "tfsm":"/TfsmActualizarModules",
      "turn": "/seguridad/module",
      "method": "put"
    },
    {
      "tfsm":"/TfsmDetalleDeModulosPorId",
      "turn": "/seguridad/moduleseByID",
      "method": "get"
    },
    {
      "tfsm":"/TfsmDetalleDePermisosPorId",
      "turn": "/seguridad/permissionByID",
      "method": "get"
    },
    {
      "tfsm":"/TfsmObtenerPermission",
      "turn": "/seguridad/permission",
      "method": "get"
    },
    {
      "tfsm":"/TfsmActualizarPermission",
      "turn": "/seguridad/permission",
      "method": "put"
    },
    {
      "tfsm":"/TfsmCrearPermission",
      "turn": "/seguridad/permission",
      "method": "post"
    },
  //el metodo Delete de bitacora/typeeventlogs no se usa
  {
    "tfsm":"/TfsmDeleteTypeLog",
    "turn": "/bitacora/typeeventlogs",
    "method": "delete"
  },
  // El metodo get de /seguridad/user no se usa
  {
    "tfsm":"/TfsmObtenerUsuarios",
    "turn": "/seguridad/user",
    "method": "get"
  },
  // El metodo put de /seguridad/user estarepetido y el de la fase uno responde mejor
  {
    "tfsm":"/TfsmUserActualizarUsuario",
    "turn": "/seguridad/user",
    "method": "put"
  },
  // El metodo post de /configurations no se usa
  {
    "tfsm":"/TfsmAccesControlSaveConfiguration",
    "turn": "/configurations",
    "method": "post"
  },
  // El metodo delete de /configurations no se usa
  {
    "tfsm":"/TfsmAccessControlDeteleConfiguration",
    "turn": "/configurations",
    "method": "delete"
  },
  // El metodo post de /bitacora/logbook no se usa
  {
    "tfsm":"/TfsmSaveBitacora",
    "turn": "/bitacora/logbook",
    "method": "post"
  },
 // EL meotdo Get de Vehicles/vehicle no se usa
  {
    "tfsm":"/TFSMGetVehiclesList",
    "turn": "/vehicles/vehicle",
    "method": "get"
  },
  //  
  {
    "tfsm":"/TfsmValidateVehicle",
    "turn": "/vehicles/validate",
    "method": "get"
  },
  {
    "tfsm":"/TfsmValidateInsertVehicle",
    "turn": "/vehicles/validate",
    "method": "put"
  },
  {
    "tfsm":"/TfsmValidateUpdateVehicle",
    "turn": "/vehicles/validate",
    "method": "post"
  },
  {
    "tfsm":"/TfsmLogout",
    "turn": "/seguridad/userLogout",
    "method": "get"
  },
  {
    "tfsm":"/TfsmVehicleLog",
    "turn": "/bitacora/events/vehicle-logbook",
    "method": "get"
  },
  {
    "tfsm":"/TfsmSearchVehicleDraftReport",
    "turn": "/bitacora/events/vehicle-logbook/report",
    "method": "get"
  },
  {
    "tfsm":"/ObtenerMunicipiosAgencias",
    "turn": "/groupsagencies/municipios",
    "method": "get"
  },
  {
    "tfsm":"/ObtenerEstadosAgencias",
    "turn": "/groupsagencies/infoagencia",
    "method": "get"
  },
  {
    "tfsm":"/ObtenerEstadosAgencias",
    "turn": "/groupsagencies/estados",
    "method": "get"
  },

  /////////////////////////

  //exportFiles 
  {
    "tfsm":"/TfsmExportFiles",
    "turn": "/exportfiles",
    "method": "post"
  },
  {
    "tfsm":"/TfsmHealthCheck",
    "turn": "/exportfiles/healthcheck",
    "method": "get"
  },
]

// console.log('total', services.length);

function transformServiceUrl(url, environmentKey, method) {

  return new Promise((resolve, reject) => {
    // Separar la URL base de los query parameters
    const urlParts = url.split('?');
    const urlPath = urlParts[0];
    const queryString = urlParts.length > 1 ? '?' + urlParts.slice(1).join('?') : '';
    
    const matchingMethod = services.filter(service => service.method === method).sort((a, b) => b.turn.length - a.turn.length);
    
    const  matchingService = matchingMethod.find(service => {

        // si el servicio tiene un idDinamic se debe de hacer un replace de los valores dinamicos
        if (service.idDinamic) {
          const tfsmRegex = new RegExp("^" + service.tfsm.replace(/:[^\s/]+/g, '[^/]+') + "$");
          const turnRegex = new RegExp("^" + service.turn.replace(/:[^\s/]+/g, '[^/]+') + "$");
          return tfsmRegex.test(urlPath) || turnRegex.test(urlPath);
        } else {
          // si el servicio no tiene un idDinamic se debe de hacer un replace de los valores estaticos
          // Verificar si la ruta base coincide (sin query parameters)
          return urlPath.includes(service.tfsm) || urlPath.includes(service.turn) || 
                 urlPath === service.tfsm || urlPath === service.turn ||
                 urlPath.startsWith(service.tfsm + '/') || urlPath.startsWith(service.turn + '/');
        }
      });
     
    if (matchingService && matchingService.turn) {
      // Reemplazar solo la parte del path, preservando query parameters
      let replacedPath = urlPath;
      
      // Si la URL coincide exactamente con turn, reemplazar completamente
      if (urlPath === matchingService.turn || urlPath.startsWith(matchingService.turn + '/')) {
        replacedPath = urlPath.replace(matchingService.turn, matchingService.tfsm);
      } else if (urlPath.includes(matchingService.turn)) {
        // Si está incluido en algún lugar, reemplazar
        replacedPath = urlPath.replace(matchingService.turn, matchingService.tfsm);
      }
      
      // Reconstruir la URL con query parameters
      const replacedUrl = replacedPath + queryString;
      resolve({ url: replacedUrl, fromOrigin: !!(matchingService.fromOrigin) });
    } else {
      resolve({ url, fromOrigin: false });
    }
  });
}


export default transformServiceUrl;